import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../services/api';

const BASE_DOWNLOAD = '/ecomerce/downloads';

export default function MinhasCompras() {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!paymentId) {
      setError('ID do pagamento não encontrado.');
      setLoading(false);
      return;
    }

    api.get(`/checkout/minhas-compras/${paymentId}`)
      .then(res => setData(res.data))
      .catch(() => setError('Compra não encontrada ou ainda sendo processada.'))
      .finally(() => setLoading(false));
  }, [paymentId]);

  if (loading) {
    return (
      <main className="page-container" style={{ textAlign: 'center', paddingTop: '48px' }}>
        Carregando sua compra...
      </main>
    );
  }

  if (error) {
    return (
      <main className="page-container" style={{ paddingTop: '32px' }}>
        <div className="alert-error">{error}</div>
        <Link to="/" className="btn-primary" style={{ display: 'inline-block', marginTop: '16px' }}>
          Voltar ao início
        </Link>
      </main>
    );
  }

  const { transaction, products } = data;
  const statusLabels = { approved: 'Aprovado', pending: 'Pendente', rejected: 'Recusado' };
  const statusColors = { approved: '#065f46', pending: '#92400e', rejected: '#991b1b' };
  const statusBg = { approved: '#d1fae5', pending: '#fef3c7', rejected: '#fee2e2' };
  const st = transaction.status || 'pending';

  return (
    <main className="page-container" style={{ maxWidth: '680px', margin: '0 auto', paddingTop: '32px' }}>
      <h2>Minha Compra</h2>

      {/* Status */}
      <div style={{
        padding: '16px',
        borderRadius: '10px',
        background: statusBg[st] || statusBg.pending,
        color: statusColors[st] || statusColors.pending,
        marginBottom: '24px',
        fontWeight: 600,
        fontSize: '1.05rem',
      }}>
        Status: {statusLabels[st] || st}
      </div>

      {/* Detalhes da transação */}
      <div className="card" style={{ marginBottom: '24px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <h3 style={{ marginTop: 0 }}>Detalhes da transação</h3>
        <p><strong>ID:</strong> {transaction.payment_id || '—'}</p>
        <p><strong>Valor:</strong> R$ {parseFloat(transaction.amount || 0).toFixed(2)}</p>
        <p><strong>Método:</strong> {transaction.payment_method}</p>
        <p><strong>Data:</strong> {transaction.date_created ? new Date(transaction.date_created).toLocaleString('pt-BR') : '—'}</p>
      </div>

      {/* Produtos */}
      {products?.length > 0 && (
        <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <h3 style={{ marginTop: 0 }}>Produtos adquiridos</h3>
          {products.map((p, idx) => (
            <div key={idx} style={{ paddingBottom: '16px', borderBottom: idx < products.length - 1 ? '1px solid #e2e8f0' : 'none' }}>
              <p style={{ fontWeight: 600, margin: '0 0 8px' }}>{p.nome}</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {p.file_name && (
                  <a href={`${BASE_DOWNLOAD}/file/${p.file_name}`} className="btn-primary" style={{ fontSize: '0.85rem', textDecoration: 'none', padding: '8px 14px' }}>
                    Baixar arquivo
                  </a>
                )}
                {p.video_file && (
                  <a href={`${BASE_DOWNLOAD}/video/${p.video_file}`} className="btn-secondary" style={{ fontSize: '0.85rem', textDecoration: 'none', padding: '8px 14px' }}>
                    Baixar vídeo
                  </a>
                )}
                {p.audio_file && (
                  <a href={`${BASE_DOWNLOAD}/audio/${p.audio_file}`} className="btn-secondary" style={{ fontSize: '0.85rem', textDecoration: 'none', padding: '8px 14px' }}>
                    Baixar áudio
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <Link to="/" className="btn-secondary" style={{ display: 'inline-block', marginTop: '24px', textDecoration: 'none' }}>
        Voltar ao início
      </Link>
    </main>
  );
}
